import { ButtonText } from '@abtasty/design-system';
import { styled } from 'styled-components';

export const NavigationButton = styled(ButtonText)`
  position: absolute;
  top: 24px;
  left: 24px;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;
export const Title = styled.h2`
  font-size: 22px;
  font-weight: bold;
`;

export const SubTitle = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.dec.color.primary.default.fg.minimal};
`;

export const VariationName = styled.div`
  color: ${({ theme }) => theme.dec.color.primary.default.fg.positive};
  margin-top: 5px;
  font-weight: bold;
`;

export const Header = styled.div`
  width: 100%;
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 24px;
  gap: 12px;
`;
